import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  HomologacionConsultaRes,
  HomologacionReq,
  HomologacionVara,
} from "../shared/model/iso42001/homologacion-modelo.model";

/**
 * Homologación de Modelos IA · consulta: la comparativa entre modelos y el
 * Resultado resumido. La usan la pantalla de consulta y la pestaña
 * Comparativa de la gestión (el servidor acepta las dos llaves).
 *
 * El servidor contesta con beans que no tienen dónde llevar el documento:
 * esta pantalla nunca lo recibe.
 */
@Injectable({ providedIn: "root" })
export class HomologacionConsultaService {
  constructor(private http: HttpClient) {}

  /** Las varas con cuántos modelos tiene cada una; marca la del vigente. */
  varas(): Observable<HomologacionConsultaRes> {
    return this.http.post<HomologacionConsultaRes>(UrlConstantes.HOMOLOGACION_MODELOS_CONSULTA_VARAS, {});
  }

  /** Los modelos evaluados, cada uno con su última evaluación no reemplazada. */
  modelos(): Observable<HomologacionConsultaRes> {
    return this.http.post<HomologacionConsultaRes>(UrlConstantes.HOMOLOGACION_MODELOS_CONSULTA_MODELOS, {});
  }

  comparativa(vara: HomologacionVara): Observable<HomologacionConsultaRes> {
    const req: HomologacionReq = {
      hashRubrica: vara.hashRubrica,
      hashSuite: vara.hashSuite,
      hashPrompts: vara.hashPrompts,
    };
    return this.http.post<HomologacionConsultaRes>(UrlConstantes.HOMOLOGACION_MODELOS_CONSULTA_COMPARATIVA, req);
  }

  /** Encabezado, KPIs, gates, rubros y capacidad por tarea. */
  resultado(idEval: number): Observable<HomologacionConsultaRes> {
    const req: HomologacionReq = { idEval };
    return this.http.post<HomologacionConsultaRes>(UrlConstantes.HOMOLOGACION_MODELOS_CONSULTA_RESULTADO, req);
  }

  /** La ficha del catálogo vigente de un modelo, de columnas: nunca el archivo. Sin descarga. */
  ficha(idModelo: number): Observable<HomologacionConsultaRes> {
    const req: HomologacionReq = { idModelo };
    return this.http.post<HomologacionConsultaRes>(UrlConstantes.HOMOLOGACION_MODELOS_CONSULTA_FICHA, req);
  }
}
